import { Suspense, lazy } from 'react';

import { isBot } from '../../constants/misc';

const InAppMessage = lazy(() => import('./InAppMessageContainer'));

interface Props {
  testID: string;
}

export default function lazyInAppMessage(props: Readonly<Props>) {
  if (isBot) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <InAppMessage {...props} />
    </Suspense>
  );
}
